document.documentElement.classList.add('dmxCloak');

document.addEventListener('DOMContentLoaded', function() {
    window.requestAnimationFrame(function() {
        document.documentElement.classList.remove('dmxCloak');
    });
});
